module.exports = __webpack_public_path__ + "img/skillhub.baf515ed.png";